"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = JobSearch;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function JobSearch(_ref) {
  var moduleClass = _ref.moduleClass,
      openings = _ref.openings,
      url = _ref.url;

  return _react2.default.createElement(
    "div",
    {
      className: "job-openings type-job_search " + moduleClass
    },
    _react2.default.createElement(
      "div",
      { className: "jobs" },
      _react2.default.createElement(
        "em",
        null,
        openings
      ),
      _react2.default.createElement("br", null),
      "Openings"
    ),
    _react2.default.createElement(
      "p",
      null,
      _react2.default.createElement(
        "a",
        { href: url, className: "button-link", target: "_blank" },
        "Find this job"
      )
    )
  );
} /*
    {
      "type": "job_search",
      "openings": 65,
      "url": ""
    }
  
    Specifically for the Job Description template, allows the
    user to search on Indeed for a particular job.
  
    Accepts the attribute openings denoting the number of available
    jobs, and url for the Indeed URL to open.
  */

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/JobSearch/JobSearch.jsx
// module id = 1212
// module chunks = 0